import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { PriceLevelsDialogData } from '@components/price-levels-dialog/1.0';
import { BadgeType } from '@constants/badge/1.0';
import { ButtonStyle } from '@constants/button/1.0';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { BossService } from '@services/boss/boss.service';
import { MessageType } from '@constants/message/1.0';
import { DeepCloneService } from '@services/utilities/1.0/deep-clone.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { MessageComponent } from '../../message/1.0/message.component';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NumbersOnlyDirective } from '../../../directives/numbers-only/1.0/numbers-only.directive';
import { ButtonComponent } from '../../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-price-levels-dialog',
  templateUrl: './price-levels-dialog.component.html',
  styleUrls: ['./price-levels-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    NgIf,
    MessageComponent,
    MatFormField,
    FormsModule,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    NumbersOnlyDirective,
    MatError,
    NgFor,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
  ],
})
export class PriceLevelsDialogComponent {
  badgeType = BadgeType; // expose enum to template
  buttonStyle = ButtonStyle;
  formSubmitted = false;
  isLoading = false;
  messageType = MessageType;
  showError = false;
  priceLevels = ['2', '3', '4', '5', '6'];
  form: UntypedFormGroup;

  constructor(
    private bossService: BossService,
    private dialogRef: MatDialogRef<PriceLevelsDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: PriceLevelsDialogData,
  ) {
    this.form = this.formBuilder.group({
      price: new UntypedFormControl(''),
      priceLevels: new UntypedFormGroup({}),
    });

    const priceLevelsControl = this.form.get('priceLevels') as UntypedFormGroup;

    this.priceLevels.forEach((level) => {
      priceLevelsControl.addControl(level, new UntypedFormControl(''));
    });

    const formData = DeepCloneService.clone(this.data.item);

    formData.priceLevels = Object.keys(formData.priceLevels || {}).reduce((obj, key) => {
      if (formData.priceLevels[key]) {
        obj[key] = parseFloat(formData.priceLevels[key]);
      }

      return obj;
    }, {});

    this.form.patchValue(formData);
  }

  handleCancel() {
    this.dialogRef.close();
  }

  handleDone() {
    this.form.markAllAsTouched();
    this.formSubmitted = true;

    if (!this.form.valid) {
      return;
    }

    const body = DeepCloneService.clone(this.form.value);
    let obs: any;

    body.priceLevels = Object.keys(body.priceLevels).reduce((obj, key) => {
      if (body.priceLevels[key]) {
        obj[key] = parseFloat(body.priceLevels[key]);
      }

      return obj;
    }, {});

    if (this.data.selectedStore) {
      obs = this.bossService.updateItemByStore(
        this.data.selectedStore,
        this.data.item.itemId,
        body,
      );
    } else {
      obs = this.bossService.updateItem(body, this.data.item.itemId);
    }

    this.isLoading = true;

    obs.subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close(body);
      },
      error: () => {
        this.showError = true;
        this.isLoading = false;
      },
    });
  }
}
